<template>
  <div class="ticket-content">
    <h3>{{ "پیام" }}</h3>
    <vs-row>
      <vs-col v-if="titleVisible">
        <p class="mb-1">{{ "موضوع" }}</p>
        <vs-input v-model="title" class="w-100 mt-1" />
      </vs-col>
      <vs-col>
        <editor
          ref="editorRef"
          :api-key="editorApiKey"
          v-model="content"
          :init="{
            height: 350,
            width: '100%',
            menubar: false,
            branding: false,
            color_default_foreground: '#fff',
            statusbar: false,
            plugins: [
              'advlist',
              'autolink',
              'lists',
              'link',
              'image',
              'charmap',
              'preview',
              'anchor',
              'searchreplace',
              'visualblocks',
              'code',
              'fullscreen',
              'insertdatetime',
              'media',
              'table',
              'code',
              'help',
              'wordcount',
            ],
            toolbar: 'bold italic ' + '| bullist numlist outdent indent',
            // toolbar:
            //   'bold italic | alignleft aligncenter ' +
            //   'alignright alignjustify | bullist numlist outdent indent',
            content_style: `body { direction: rtl; }`,
          }"
        />
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@tinymce/tinymce-vue";

export default {
  name: "FormContent.vue",
  components: { Editor },
  data() {
    return {
      title: "",
      content: "",
      editorApiKey: process.env.VUE_APP_EDITOR_API_KEY,
    };
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  methods: {
    getData() {
      return {
        title: this.title,
        content: this.content,
      };
    },
  },
  props: {
    titleVisible: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style lang="scss">
.ticket-content {
  flex: 1;

  h3 {
    margin-bottom: 20px;
  }
}
</style>

